export const INITIAL_VALUES = {
  email: "",
  password: ""
};

export const REQUIRED_MESSAGE = "Campo requerido";
